import Marionette from "backbone.marionette";
import Radio from "backbone.radio";
import GenericModel from "../../../../models/generic";
import ReportLegend from "../../../../behaviors/report-legend";
import DataTable from "../../../datatable/report";
import mix from "../../../../utils/mixin-builder";
import DTConfigMixin from "../../../../mixins/datatable/configuration";
import DTButtonsMixin from "../../../../mixins/datatable/buttons";
import DataTableConfigurator from "../../../../common/datatable-configurator";
import templates from "../../../../utils/templates";

const DEFAULTS = {
  tagName: "form",
  template: templates.find("layout", "report_container"),
  // treat as drilldown
  activeRegion: true,
};

const ROUTE = "chart-reviews:drg-adds-file-history";
const REPORT_OPTS = {
  eventName: `${ROUTE}-configuration-ready`,
  route: ROUTE,
  navigation: {},
};

const globalChannel = Radio.channel("global");
const reportChannel = Radio.channel("report");

class View extends mix(Marionette.LayoutView).with(
  DTConfigMixin,
  DTButtonsMixin
) {
  constructor(options = {}) {
    _.defaults(options, DEFAULTS);
    super(options);
  }

  regions() {
    return {
      legend: ".report-legend",
      filters: ".report-filters",
      actions: ".report-actions",
      report: ".table-container",
    };
  }

  behaviors() {
    return [{ behaviorClass: ReportLegend }];
  }

  initialize() {
    // create view model
    this.model = new GenericModel({
      route: ROUTE,
    });

    // namespaced event names
    this.customizeViewEvent = `${ROUTE}.customize-view`;
    this.afterAjaxEvent = `${ROUTE}.after-ajax`;
    this.filtersUpdatedEvent = `${ROUTE}.filters-updated`;
    this.reportingPreferencesUpdatedEvent = `${ROUTE}.reporting-preferences-updated`;
    this.reportingPreferencesReorderedEvent = `${ROUTE}.report-columns-reordered`;

    // setup listeners
    this.listenTo(reportChannel, REPORT_OPTS.eventName, this._renderReport);
    // used by config mixin
    this.listenTo(
      reportChannel,
      this.filtersUpdatedEvent,
      this._onFiltersUpdated
    );
    this.listenTo(globalChannel, this.customizeViewEvent, this._customizeView);
    this.listenTo(
      reportChannel,
      this.reportingPreferencesUpdatedEvent,
      this._onReportingPreferencesUpdate
    );
    this.listenTo(
      reportChannel,
      this.reportingPreferencesReorderedEvent,
      this._onReportColumnsReordered
    );

    // used by mixins and custom events
    this.listenTo(reportChannel, this.afterAjaxEvent, this._onAfterAjax);
  }

  _onAfterAjax(data) {
    // call mixin method
    this.addButtons(data);

    // fire custom event
    this.triggerMethod("ReportLegend", data.model.getMeta().getLegend());
  }

  onBeforeShow() {
    // get custom report configuration, if it exists
    const preferences = reportChannel.request("preferences:find", ROUTE);

    // extend search options with view options and criteria
    const options = Object.assign({}, REPORT_OPTS, this.options, {
      customColumns: preferences ? preferences.get("columns") : null,
      customColumnsCreated: preferences ? preferences.get("_created") : null,
    });

    // fire off DT configurator
    new DataTableConfigurator(options);
  }

  _renderReport(config) {
    // localize report config options
    this.reportConfig = config;

    // set the table's ID to the route name
    // in order to save a unique state.
    this.reportConfig.id = config.route;

    // used to calculate DT height
    this.reportConfig.isDrilldown = true;

    // inject after ajax event name
    this.reportConfig.afterAjaxEvent = this.afterAjaxEvent;

    this.report.show(new DataTable(this.reportConfig));
  }

  _onFiltersUpdated(data) {
    // hide report
    // this.report.$el.fadeOut(1);

    // update report config params
    this.reportConfig.params = data;

    this.report.show(new DataTable(this.reportConfig));
  }
}

export { View as default };
